import { getPageAllowedRoles } from "../../config/roles";
import { fullWidth } from "../../blocks/layout/columnSpans";
import { PageDefinition } from "../pageDefinition.types";
import { WarehouseApplicationLinks } from "./WarehouseApplicationLinks";

/** The systems allowed to use the Warehouse API, each opened from its card. */
export const warehouseApplicationsPageDefinition: PageDefinition = {
  path: "/warehouse-applications",
  title: "Warehouse Applications",
  allowedRoles: getPageAllowedRoles("warehouse-applications"),
  back: { route: "/settings", title: "Back to settings" },
  newLink: { route: "/warehouse-application" },
  rows: [
    {
      id: "row-applications",
      panels: [
        {
          id: "panel-applications",
          // The page bar already says Warehouse Applications.
          title: "",
          span: fullWidth,
          component: WarehouseApplicationLinks,
          plain: true,
        },
      ],
    },
  ],
};
